import { Skeleton, Alert, Select, Tooltip, Badge, Card } from "antd";
import { LuNotebookPen } from "react-icons/lu";
import dayjs from "dayjs";

import "../style.css";
import "./style.css";
import { limitarTexto25 } from "../../../../function/utilis/function";

const TabelaOrdensServico = ({
  nomeAnalista,
  setNomeAnalista,
  loading,
  paginatedData,
  setIdSelecionado,
  setIsModalPortalContadorOS,
  formatarObservacoes,
  setObservacoesAtuais,
  setIsMostrarObservacao,
  ultimaDataObservacao,
  diasDesdeUltimaObservacao,
  analistasUnicos,
}) => {
  return (
<div
  className="tabela-container"
  style={{
    width: loading || paginatedData.length === 0 ? "1290px" : undefined
  }}
>


  {/* Filtro */}
  <div className="filtro">
    <Select
      mode="multiple"
      allowClear
      style={{ width: 250 }}
      placeholder="Selecionar analista"
      value={nomeAnalista}
      onChange={(values) => setNomeAnalista(values)}
    >
      {analistasUnicos.map((analista) => (
        <Select.Option
          key={analista.idAnalista}
          value={analista.idAnalista}
        >
          {analista.idAnalista}
        </Select.Option>
      ))}
    </Select>
  </div>

  {loading ? (
    <div className="loading">
      <span>Carregando tabela, por favor aguarde...</span>
      <Skeleton active />
    </div>
  ) : paginatedData.length > 0 ? (
    <>
      {/* Cabeçalho da tabela */}
      <div className="tabela-header-dash">
        <div className="col" style={{textAlign: "center"}}>Analista</div>
        <div className="col" style={{textAlign: "center"}}>OS</div>
        <div className="col" style={{textAlign: "center"}}>ID</div>
        <div className="col" style={{textAlign: "center"}}>Razão/Nome</div>
        <div className="col" style={{textAlign: "center"}}>Obs</div>
        <div className="col" style={{textAlign: "center"}}>Data OS</div>
        <div className="col" style={{textAlign: "center"}}>Última obs</div>
        <div className="col" style={{textAlign: "center"}}>Dias</div>
        <div className="col" style={{width: "250px", textAlign: "center"}}>Tipo de OS</div>
        <div className="col">Situação</div>
      </div>

      {/* Linhas (Cards) */}
      <div className="tabela-grid">
        {paginatedData.map((item) => {
          const dias = diasDesdeUltimaObservacao(item.observacao);

          return (
            <Badge.Ribbon
              key={item.id}
              text={item.situacao?.nome || "Sem status"}
              color={
                item.situacao?.nome === "Cancelada"
                  ? "red"
                  : item.situacao?.nome === "Processo Concluído"
                  ? "green"
                  : item.situacao?.nome === "Inicial"
                  ? "blue"
                  : item.fgExecucaoSuspensa === true 
                  ? "rgb(255, 167, 0)"
                  : "#005a9e"
              }
            >
              <Card size="small" hoverable className="tabela-card-dash">
                <div className="tabela-linha">
                 <Tooltip title={item.usuarioAtribuicao?.id}>
                   <div
                    className="col"
                  >
                    {item.usuarioAtribuicao?.id === null
                ? "Não atribuído"
                : item.usuarioAtribuicao?.id}
                  </div>
                 </Tooltip>

                  <div
                  style={{textAlign: "center"}}
                    className="col clickable"
                    onClick={() => {
                      setIdSelecionado(item.id);
                      setIsModalPortalContadorOS(true);
                    }}
                  >
                    {item.id}
                  </div>
                  <div className="col" style={{textAlign: "center"}}>{item.cliente?.id || "0000"}</div>
                  <div className="col" style={{textAlign: "center"}}>
                    
                    <Tooltip title={item.cliente?.nome}>
                      {item.cliente?.nome === null || item.cliente?.nome === "" ? <span className="sem-obs">Nenhum empresa</span> : limitarTexto25(item.cliente?.nome)} /
                    </Tooltip>

                    <Tooltip title={item.contato?.nome}>
                      <strong>{item.contato?.nome === null || item.contato?.nome === "" ? <span>Nenhum</span> : limitarTexto25(item.contato?.nome)}</strong>
                    </Tooltip>
                  </div>
                  <div className="col" style={{textAlign: "center"}}>
                    {item.observacao ? (
                      <Tooltip title="Visualizar observação">
                        <span
                          className="btn-mostra-ob"
                          onClick={() => {
                            const resultado = formatarObservacoes(item.observacao);
                            setObservacoesAtuais(resultado);
                            setIsMostrarObservacao(true);
                          }}
                        >
                          <LuNotebookPen />
                        </span>
                      </Tooltip>
                    ) : (
                      <span className="sem-obs">Nenhuma</span>
                    )}
                  </div>
                  <div className="col" style={{textAlign: "center"}}>
                    {dayjs(item.dataParalegal).format("DD/MM/YYYY")}
                  </div>
                  <div className="col" style={{textAlign: "center"}}>
                    {ultimaDataObservacao(item.observacao) ?? "Sem data"}
                  </div>
                  <div className="col" style={{textAlign: "center"}}>
                    {!(item.fgExecucaoSuspensa ||
                      ["F", "C", "F-DOC"].includes(item.situacao?.id)) &&
                      dias !== null &&
                      dias !== undefined && (
                        <span
                          className={`dias ${
                            dias > 4 ? "red" : dias > 3 ? "yellow" : "blue"
                          }`}
                        >
                          {dias} dias
                        </span>
                      )}
                  </div>
                  <div className="col" style={{width: "250px", textAlign: "center"}}>
                    <strong>{item.tipo?.nome}</strong>
                  </div>
                </div>
              </Card>
            </Badge.Ribbon>
          );
        })}
      </div>
    </>
  ) : (
    <Alert
      message="Nenhuma Ordem de serviço encontrada"
      type="info"
      showIcon
    />
  )}
</div>



  );
};

export default TabelaOrdensServico;
